<template>
    <div class="top-bar">
        <div class="top-bar-items">
            <slot/>
        </div>
        <div class="top-bar-utils">
            <div class="top-bar-utils-action">
                {{runningImportProcesses.length === 0 ? 'No imports running' : `${runningImportProcesses.length} imports running` }}
            </div>
            <div class="top-bar-utils-action">
                    {{actualUser.userName}}
                <div class="user-icon">
                    {{actualUser.role[0].toUpperCase()}}
                </div>
                <div class="user-icon action" @click="logout">
                    <icon :icon="['far', 'sign-out']"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopBarGroup from "./TopBarGroup";
    import {mapGetters} from "vuex";
    export default {
        name: "TopBar",
        components: {TopBarGroup},
        data: function () {
            return {
                importProcessHandle: null
            }
        },
        mounted() {
            this.importProcessHandle = setInterval(() => {
                this.$store.dispatch('importProcesses/refreshRunningImportProcesses')
            }, 30000)
        },
        methods: {
            logout() {
                 fetch('/',
                     {
                         headers: { Authorization: 'Basic AAAAAAAAAAAAAAAAAAA=' }
                     }).then(
                     () => window.location = window.location.protocol + '//xxxx:xxxx@' + window.location.host + "/logout"
                 );
            }
        },
        computed: {
            ... mapGetters({
                'runningImportProcesses': 'importProcesses/getRunningProcesses',
                'actualUser': 'security/actualUser'
            })
        },
        destroyed() {
            clearInterval(this.importProcessHandle);
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.user-icon {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background-color: var(--card-font-color);
    color: var(--background-color);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 15px;
}

.top-bar {
    font-size: 14px;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    color: var(--card-font-color);
}

.top-bar-items {
    display: flex;
    flex-flow: row;
    justify-items: center;
    align-items: center;
}

.top-bar-items>* {
    margin: 0px 10px 0 10px;
}

.top-bar-utils {
    display: flex;
    grid-area: 1/2/1/3;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
}

.top-bar-utils-action {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 10px;
    margin-right: 10px;
}

.action {
    cursor: pointer;
}

.action:hover {
    background-color: #a2bbd4;
}
</style>